/* VES · 07 Equipo — navegador de profesionales (master-detail) con autoplay.
   Build: ves-team-20260717-autoplay-v4
   Píldora = área. Flechas = rotan los profesionales del área de a uno.
   AUTOPLAY (programable): avanza el profesional cada X segundos; al terminar
   los de un área, cambia a la siguiente área y sigue con los suyos, en bucle
   infinito. Pausa al pasar el cursor / al enfocar, con pestaña oculta y con
   prefers-reduced-motion. Sin JS: primer grupo/primer profesional visibles. */
(function () {
  'use strict';

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initTeam(root) {
    var pills = Array.prototype.slice.call(root.querySelectorAll('.ves-team__pill'));
    var groupEls = Array.prototype.slice.call(root.querySelectorAll('.ves-team__group'));
    if (!groupEls.length) return;

    // Modelo ordenado de áreas (sigue el orden canónico del render).
    var areas = groupEls.map(function (g) {
      return {
        key: g.getAttribute('data-group'),
        group: g,
        members: Array.prototype.slice.call(g.querySelectorAll('.ves-team__member')),
        counter: g.querySelector('[data-counter]'),
        prev: g.querySelector('[data-prev]'),
        next: g.querySelector('[data-next]'),
        mi: 0
      };
    });

    var activeIdx = 0;

    function showGroupByIndex(idx) {
      activeIdx = (idx + areas.length) % areas.length;
      var key = areas[activeIdx].key;
      pills.forEach(function (p) {
        var on = p.getAttribute('data-target') === key;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      areas.forEach(function (a, i) {
        var on = i === activeIdx;
        a.group.classList.toggle('is-active', on);
        if (on) { a.group.removeAttribute('hidden'); } else { a.group.setAttribute('hidden', ''); }
      });
    }

    function showMember(area, n) {
      if (!area.members.length) return;
      area.mi = (n + area.members.length) % area.members.length;
      area.members.forEach(function (m, idx) {
        var on = idx === area.mi;
        m.classList.toggle('is-active', on);
        if (on) { m.removeAttribute('hidden'); } else { m.setAttribute('hidden', ''); }
      });
      if (area.counter) area.counter.textContent = (area.mi + 1) + ' / ' + area.members.length;
    }

    // ---------- Autoplay ----------
    var totalMembers = areas.reduce(function (s, a) { return s + a.members.length; }, 0);
    var autoOn = root.getAttribute('data-autoplay') === 'true';
    var ms = parseInt(root.getAttribute('data-autoplay-ms'), 10);
    if (isNaN(ms) || ms < 1500) ms = 5000;
    var canAuto = autoOn && !REDUCE && totalMembers > 1;
    var timer = null, hovering = false;

    function nextNonEmptyArea(from) {
      var ni = from, guard = 0;
      do { ni = (ni + 1) % areas.length; guard++; } while (areas[ni].members.length === 0 && guard <= areas.length);
      return ni;
    }

    function step() {
      var area = areas[activeIdx];
      if (area.mi + 1 < area.members.length) {
        showMember(area, area.mi + 1);
      } else {
        // Terminó el área: pasa a la siguiente y arranca desde su primero.
        var ni = nextNonEmptyArea(activeIdx);
        if (ni !== activeIdx) {
          showGroupByIndex(ni);
          showMember(areas[ni], 0);
        } else {
          showMember(area, 0); // única área: vuelve al primero
        }
      }
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (canAuto && !timer && !hovering && !document.hidden) timer = setInterval(step, ms); }
    function restart() { stop(); start(); }

    // ---------- Interacción manual ----------
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = -1;
        areas.forEach(function (a, i) { if (a.key === pill.getAttribute('data-target')) idx = i; });
        if (idx >= 0) { showGroupByIndex(idx); restart(); }
      });
    });

    areas.forEach(function (area) {
      if (area.members.length < 2) return;
      if (area.prev) area.prev.addEventListener('click', function () { showMember(area, area.mi - 1); restart(); });
      if (area.next) area.next.addEventListener('click', function () { showMember(area, area.mi + 1); restart(); });
    });

    if (canAuto) {
      root.addEventListener('mouseenter', function () { hovering = true; stop(); });
      root.addEventListener('mouseleave', function () { hovering = false; start(); });
      root.addEventListener('focusin', function () { hovering = true; stop(); });
      root.addEventListener('focusout', function () { hovering = false; start(); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });
      start();
    }

    // ---------- Cinta de tips: botón de pausa (WCAG 2.2.2) ----------
    var ticker = root.querySelector('.ves-team__ticker');
    var pauseBtn = root.querySelector('[data-pause]');
    if (ticker && pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        var p = ticker.classList.toggle('is-paused');
        pauseBtn.setAttribute('aria-pressed', p ? 'true' : 'false');
      });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ves-team]').forEach(initTeam);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
